import { defineMessages } from "react-intl";

import {
	ahbctotalMessages,
	antiHbsMessages,
	hbimmunMessages,
	hbsAgMessages,
	validator
} from "lib/build/forms/ktx/basic-registration-data/viral-serology/hbvStatus";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	hbvStatus: {
		id: "ktx.hbvStatus.title",
		defaultMessage: "HBV"
	},
	aHBctotal: {
		id: "ktx.hbvStatus.field.aHBctotal",
		defaultMessage: "aHBc totál"
	},
	antiHBs: {
		id: "ktx.hbvStatus.field.antiHBs",
		defaultMessage: "antiHBs"
	},
	antiHBsValue: {
		id: "ktx.hbvStatus.field.antiHBsValue",
		defaultMessage: "antiHBs értéke"
	},
	HBsAg: {
		id: "ktx.hbvStatus.field.HBsAg",
		defaultMessage: "HBsAg"
	},
	HBImmun: {
		id: "ktx.hbvStatus.field.HBImmun",
		defaultMessage: "HB immunizáció"
	}
});

const fields: { [key: string]: FieldData } = {
	aHBctotal: {
		type: "field",
		path: ["aHBctotal"],
		label: messages.aHBctotal,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: ahbctotalMessages } }
	},
	antiHBs: {
		type: "field",
		path: ["antiHBs"],
		label: messages.antiHBs,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: antiHbsMessages } }
	},
	antiHBsValue: {
		type: "field",
		path: ["antiHBsValue"],
		label: messages.antiHBsValue,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	},
	HBsAg: {
		type: "field",
		path: ["HBsAg"],
		label: messages.HBsAg,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: hbsAgMessages } }
	},
	HBImmun: {
		type: "field",
		path: ["HBImmun"],
		label: messages.HBImmun,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: hbimmunMessages } }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.aHBctotal }] },
		{ columns: [{ width: 12, field: fields.antiHBs }] },
		{ columns: [{ width: 12, field: fields.antiHBsValue }] },
		{ columns: [{ width: 12, field: fields.HBsAg }] },
		{ columns: [{ width: 12, field: fields.HBImmun }] }
	]
};

export const node: LeafNode = {
	id: "ktx_hbvStatus",
	value: {
		schemaId: "hbvStatus",
		title: messages.hbvStatus,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
